import { render } from "./ProductStockDetailsProductData.vue?vue&type=template&id=67fa0ce1"
import script from "./ProductStockDetailsProductData.vue?vue&type=script&lang=js"
export * from "./ProductStockDetailsProductData.vue?vue&type=script&lang=js"
script.render = render

export default script